import Main from './main.ts';

document.addEventListener( 'DOMContentLoaded', function () {
	new Main();
	let currentStatusBrowser = {
		desktop:window.matchMedia('(min-width: 1241px)').matches,
		tablet:window.matchMedia('(min-width:601px) and (max-width:1240px)').matches,
		mobile:window.matchMedia('(max-width: 600px)').matches,
	}
	window.addEventListener('resize',function(){
		let getWindowSize = window.innerWidth
		if((getWindowSize > 600 && getWindowSize < 1241 && currentStatusBrowser.tablet === false) || (getWindowSize < 601 && currentStatusBrowser.mobile === false) || (getWindowSize > 1241 && currentStatusBrowser.desktop === false)){
			window.location.reload()
		}
	})
} );
